import { render, staticRenderFns } from "./PreguntasTabla.vue?vue&type=template&id=5be889c2&"
import script from "./PreguntasTabla.vue?vue&type=script&lang=js&"
export * from "./PreguntasTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports